import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { transportationDirections } from './TransportationEmployees'
import { addTransportationSettings } from 'features/transportation/transportationSlice'

export const TransportationSettingsModal = ({ closeModal, value }: { closeModal: any, value?: ITransportationSettingsModalState }) => {
    const [state, setState] = useState(value || {
        user: null,
        direction: null,
        transportationZone: null,
    })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(addTransportationSettings(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleSelect = (v: ISelectValue, n: string) => {
        setState(prev => ({ ...prev, [n]: v }))
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Transportation Settings</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <HonestSelectAsyncInput
                    link='users/basic'
                    labelText='Employee'
                    name='user'
                    onChange={handleSelect}
                    parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, value: i.id }))}
                    defaultValue={state.user?.label}
                    required
                    nomarg
                />

                <HonestSelectAsyncInput
                    link='transportation/management/zone'
                    labelText='Transportation Zone'
                    name='transportationZone'
                    onChange={handleSelect}
                    parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                    defaultValue={state.transportationZone?.label}
                    required
                    nomarg
                />

                <HonestSelectInput
                    options={transportationDirections}
                    onChange={handleSelect}
                    defaultValue={state.direction?.value}
                    labelText='Direction'
                    name='direction'
                    required
                />


            </Flex>
            <Button mt='16' orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface ITransportationSettingsModalState {
    user: ISelectValue
    direction: ISelectValue
    transportationZone: ISelectValue
}